/* The configurator is the source of truth. Never use Shopify's placeholder price. */
(() => {
  'use strict';
  const currencies = /^(AUD|BRL|CAD|CHF|DKK|EUR|GBP|JPY|SEK|THB|USD)$/;
  function parsePrice(text, locale, currency) {
    try {
      const format = new Intl.NumberFormat(locale, {style: 'currency', currency,
        minimumFractionDigits: currency === 'JPY' ? 0 : 2,
        maximumFractionDigits: currency === 'JPY' ? 0 : 2});
      let value = String(text).replace(/[\s\u061c\u200e\u200f]/g, '');
      const parts = format.formatToParts(12345.67);
      for (const type of ['currency', 'group', 'decimal']) {
        for (const token of new Set(parts.filter(p => p.type === type).map(p => p.value))) {
          value = value.split(token.replace(/[\s\u061c\u200e\u200f]/g, '')).join(type === 'decimal' ? '.' : '');
        }
      }
      const digits = new Intl.NumberFormat(locale, {useGrouping: false});
      for (let i = 0; i < 10; i++) value = value.split(digits.format(i)).join(String(i));
      if (!/^\d+(\.\d{1,2})?$/.test(value)) return null;
      const amount = Number(value);
      return amount > 0 && Number.isFinite(amount) ? amount.toFixed(currency === 'JPY' ? 0 : 2) : null;
    } catch (_) { return null; }
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {parsePrice};
    return;
  }
  const schemaId = 'AlphaConfiguratorProductSchema';
  function mount(root) {
    if (root.dataset.alphaSchemaMounted) return;
    root.dataset.alphaSchemaMounted = 'true';
    const remove = () => document.getElementById(schemaId)?.remove();
    const update = () => {
      const card = root.querySelector('[data-aap-price-card]');
      const checkout = root.querySelector('[data-aap-checkout]');
      const price = root.querySelector('[data-aap-price]');
      const selection = root.querySelector('[data-aap-selection]');
      const country = root.querySelector('[data-aap-country]')?.value;
      const currencyValue = document.querySelector('[data-translation-shop-currency]')?.value;
      const fallback = currencies.test(root.dataset.aapCurrency || '') ? root.dataset.aapCurrency : 'EUR';
      const currency = currencies.test(currencyValue || '') ? currencyValue : fallback;
      const locale = (root.dataset.aapLocale || document.documentElement.lang || 'en').replace(/_/g, '-');
      const amount = price && parsePrice(price.textContent, locale, currency);
      const name = root.dataset.aapProductTitle?.trim();
      const details = selection?.textContent.trim();
      if (root.dataset.aapActiveSupport === 'hand-painted-oil' ||
          document.body.dataset.artworkBrowse === 'oil' ||
          root.getAttribute('aria-busy') !== 'false' || !card || card.hidden ||
          !checkout || checkout.disabled || !amount || !name || !details ||
          !/^[A-Z]{2}$/.test(country || '')) { remove(); return; }
      let image;
      try {
        if (!root.dataset.aapSourceUrl) { remove(); return; }
        image = new URL(root.dataset.aapSourceUrl, location.href);
        if (image.protocol !== 'https:') { remove(); return; }
      } catch (_) { remove(); return; }
      const canonical = document.querySelector('link[rel="canonical"]')?.href;
      if (!canonical) { remove(); return; }
      const offer = {'@type': 'Offer', name: details, url: location.href,
        price: amount, priceCurrency: currency, availability: 'https://schema.org/InStock',
        itemCondition: 'https://schema.org/NewCondition',
        seller: {'@type': 'Organization', name: 'Alpha Reproduction'}};
      // Shipping is part of the displayed total; do not invent delivery times or return policies.
      const included = root.querySelector('[data-aap-included-shipping]')?.textContent.trim();
      if (included) offer.shippingDetails = {'@type': 'OfferShippingDetails',
        shippingRate: {'@type': 'MonetaryAmount', value: '0', currency},
        shippingDestination: {'@type': 'DefinedRegion', addressCountry: country}};
      const product = {'@context': 'https://schema.org', '@type': 'Product',
        '@id': canonical + '#configured-reproduction', name: name.slice(0, 200),
        description: name + ' — ' + details, image: [image.href], url: canonical, offers: offer};
      const json = JSON.stringify(product);
      let script = document.getElementById(schemaId);
      if (!script) {
        script = document.createElement('script');
        script.id = schemaId;
        script.type = 'application/ld+json';
        document.head.append(script);
      }
      if (script.textContent !== json) script.textContent = json;
    };
    new MutationObserver(update).observe(root, {subtree: true, childList: true,
      characterData: true, attributes: true,
      attributeFilter: ['hidden', 'disabled', 'aria-busy', 'data-aap-active-support']});
    new MutationObserver(update).observe(document.body, {attributes: true,
      attributeFilter: ['data-artwork-browse']});
    document.addEventListener('change', update);
    update();
  }
  function start() {
    const root = document.querySelector('[data-alpha-reproduction-pod-product] [data-aap-root]');
    if (root) { mount(root); return; }
    const observer = new MutationObserver(() => {
      const pending = document.querySelector('[data-alpha-reproduction-pod-product] [data-aap-root]');
      if (pending) { observer.disconnect(); mount(pending); }
    });
    observer.observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
